import "./style.css";
import layout from "./layout.html";

export default class ContactsList {
  static selector = ".contacts__list";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
  }

  onReady = () => {};

  onComplete = () => {};

  onResize = () => {};
}
